import React from 'react';
import { Area, AreaChart, XAxis, ResponsiveContainer, Tooltip } from 'recharts';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  tooltip: {
    position: 'relative',
    borderRadius: 6,
    padding: '4px 12px',
    backgroundColor: '#E59D1E',
    color: theme.palette.common.white,
  },
}));

const RevenueGraph3 = props => {
  const classes = useStyles();
  const color = props.color;
  return (
    <ResponsiveContainer width="100%" height={112}>
      <AreaChart data={props.data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
        <XAxis dataKey="label" hide />
        <Tooltip labelStyle={{ color: 'black' }} cursor={false} />

        <defs>
          <linearGradient id="color12" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={color} stopOpacity={1} />
            <stop offset="95%" stopColor="#fff" stopOpacity={1} />
          </linearGradient>
        </defs>
        <Area dataKey="value" type="monotone" strokeWidth={2} stackId="2" stroke={color} fillOpacity={0} fill={color} />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default RevenueGraph3;
